import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { forwardRef } from 'react';
import useDndKitItem from './useDndKitItem.mjs';

const forwardedRefDndKitItem = forwardRef(function DndKitItem({
  id,
  children,
  sortableProps,
  withDragHandle,
  tabIndex = -1,
  as = "li",
  ...stitchesProps
}, ref) {
  const {
    a11yAttributes,
    listeners,
    setNodeRef,
    isDragging,
    isSorting,
    style
  } = useDndKitItem({
    id,
    sortableProps
  });
  const composedRefs = useComposedRefs(setNodeRef, ref);
  return /* @__PURE__ */ jsx(
    Item,
    {
      as,
      ...a11yAttributes,
      ...stitchesProps,
      ...withDragHandle ? void 0 : listeners,
      tabIndex,
      style: {
        ...style,
        ...stitchesProps?.style
      },
      ref: composedRefs,
      children: typeof children === "function" ? children({ listeners, isDragging, isSorting }) : children
    }
  );
});
const Item = styled("li");

export { forwardedRefDndKitItem as DndKitItem };
//# sourceMappingURL=Item.mjs.map
